export const LABOR_ENCOUNTER_CLOSEOUT_CONFIRMATION = {
  cancelButtonTestId: "labor-encounter-closeout-guard-cancel-button",
  confirmButtonColor: "burgundy.9",
  confirmButtonText: "Go to the Encounter",
  description:
    "You must close out the active Labor and Delivery encounter before closing out the current pregnancy.",
  modalTestId: "labor-encounter-closeout-guard-modal",
  title: "There is an active Labor and Delivery encounter for this client.",
} as const;

export const LABOR_ENCOUNTER_LOOKUP_ERROR = {
  message:
    "We couldn't confirm whether an active Labor and Delivery encounter exists. Try again before closing out the pregnancy.",
  title: "Unable to verify labor encounter",
} as const;
